import { takeLatest, put, select, call } from 'redux-saga/effects';

import quoteItemService from 'modules/quotes/quoteItems/data/service';
import { UPDATE_COMPONENT_SUCCESS } from 'modules/quotes/quoteItems/data/types';

import { types } from './actions';
import { liveDiscountPreview } from './actions';
import {
  getDiscountId,
  getCurrentOverrides,
  getIsDiscountModalOpen,
} from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_DISCOUNT_MODAL, watchOpenDiscountModal);
  yield takeLatest(
    types.LIVE_DISCOUNT_PREVIEW_REQUEST,
    watchLiveDiscountPreviewRequest,
  );
  yield takeLatest(UPDATE_COMPONENT_SUCCESS, watchUpdateComponentSuccess);
  yield takeLatest(types.RECEIVE_OVERRIDES, watchReceiveOverrides);
}

function* watchOpenDiscountModal(action) {
  const { payload } = action;
  const { discount } = payload;
  yield put(
    liveDiscountPreview.request({
      discountId: discount.id,
      newOverrides: discount.overrides,
    }),
  );
}

function* watchUpdateComponentSuccess() {
  const discountId = yield select(getDiscountId);
  const overrides = yield select(getCurrentOverrides);
  const isOpen = yield select(getIsDiscountModalOpen);
  if (isOpen) {
    yield put(
      liveDiscountPreview.request({
        discountId: discountId,
        newOverrides: overrides,
      }),
    );
  }
}

function* watchLiveDiscountPreviewRequest(action) {
  try {
    const { payload } = action;
    const { discountId, overrides } = payload;
    const response = yield call(
      quoteItemService.discounts.livePricing,
      discountId,
      {
        overrides,
      },
    );
    yield put(liveDiscountPreview.success(response));
  } catch (error) {
    console.error(error);
    yield put(liveDiscountPreview.error);
  }
}

function* watchReceiveOverrides(action) {
  const { payload } = action;
  const { nextOverrides } = payload;
  const discountId = yield select(getDiscountId);
  yield put(
    liveDiscountPreview.request({
      discountId: discountId,
      newOverrides: nextOverrides,
    }),
  );
}
